<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_open_chat')
}

const isOnChatSection = computed(() => {
  return route.path.startsWith('/communication')
})

const goToChat = () => {
  router.push('/communication')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/news.webm"
  >
    <template #text>
      <p class="pb-2">
        Welcome to the Communication Center!
      </p>
      <p class="pb-2">
        Here you can have private chats with other civilization or group chats with your alliance.
      </p>
      <p class="pb-2">
        Try sending a friendly message to introduce yourself to your new neighbor!
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        Click on the "+" icon and select the empire you have just met. Then send a message!
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnChatSection" @click="goToChat" class="mr-2">
        Go to Communication
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Got it!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>